import * as _ from "lodash";
import { log2 } from "./log2";
import { IS_PROD_ENVIRONMENT, IS_STAGE_ENVIRONMENT } from "./utils";

const showChildrenState = {};
const log = log2("Menu");
export default (that) => {
    return [
        {
            title: "Cluster Dashboard",
            path: "/cluster-dashboard",
            icon: "cluster-dashboard",
            showChildren: false,
            isAdmin: true,
            enabled: true,
        },
        {
            title: "Invoices",
            path: "/invoices",
            icon: "CreditCard",
            showChildren: false,
            isAdmin: true,
            enabled: true,
        },
        {
            title: that.$t("adminUser.adminUsers"),
            path: "/admin-users",
            icon: "users",
            isAdmin: true,
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.sites"),
            path: "/sites",
            icon: "site",
            isAdmin: true,
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.globalSettings"),
            path: "/global-settings",
            icon: "cogs",
            isAdmin: true,
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.feedback"),
            path: "/ErrorReports",
            icon: "cogs",
            antIcon: "bug",
            isAdmin: true,
            showChildren: false,
            enabled: true,
        },
        {
            title: "Chat",
            path: "/chat",
            icon: "comments",
            permission: "chat.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: "ChatBot",
            path: "/chatbot",
            icon: "chatbot",
            permission: "chatbot",
            showChildren: false,
            enabled: true,
        },
        {
            title: "Ticket",
            path: "/ticket",
            icon: "ticket",
            permission: "ticket",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.archive"),
            path: "/archives",
            icon: "history",
            permission: "archives.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.offlineSupportRequests"),
            path: "/offline-support-requests",
            icon: "offline-support",
            permission: "offlineSupportRequest.get",
            showChildren: false,
            enabled: false,
        },
        {
            title: that.$t("message.roles"),
            path: "/roller",
            icon: "masks",
            permission: "role.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.users"),
            path: "/kullanicilar",
            icon: "users",
            permission: "user.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.bannedVisitors"),
            path: "/yasakli-ziyaretciler",
            icon: "user-slash",
            permission: "bannedVisitor.view",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.departments"),
            path: "/konular",
            icon: "clipboard-list",
            permission: "topic.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.defaultContents"),
            path: "/hazir-icerikler",
            icon: "box-open",
            permission: "prepared.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.welcomeMessages"),
            path: "/karsilama-mesajlari",
            icon: "hand-paper",
            permission: "welcome.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.catalogCategories"),
            path: "/katalog",
            icon: "Catalog",
            permission: "catalog.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.bannedWords"),
            path: "/yasakli-kelimeler",
            icon: "ban",
            permission: "bannedWord.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.getApps"),
            path: "/uygulamalar",
            icon: "apps",
            permission: "",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("message.settings"),
            path: "/ayarlar",
            icon: "cogs",
            permission: "setting.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: "Whatsapp",
            path: "/integrations/whatsapp",
            icon: "whatsapp",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("billing.billingPlanSettings"),
            path: "/billing",
            icon: "CreditCard",
            permission: "setting.get",
            showChildren: false,
            enabled: true,
        },
        {
            title: that.$t("report.reports"),
            path: "/report-new",
            icon: "DetailReports",
            permission: "report.get",
            enabled: true,
        },
    ];
};

export const toggleShowChildren = (path) => {
    log("toggleShowChildren called", path);
    if (showChildrenState[path] !== undefined) {
        showChildrenState[path] = !showChildrenState[path];
    } else {
        showChildrenState[path] = true;
    }
};
